"use client";

import { c as _c } from "react/compiler-runtime";
import { APP_DATA, AppDataResolved } from "@/constants/appData";
import { useTheme } from "@/features/theme";
import { useMemo } from "react";

/**
 * Hook que resuelve los assets temáticos según el tema actual.
 * Convierte objetos ThemedAsset { light, dark } en strings con la ruta correcta.
 *
 * @returns Datos de la aplicación con las rutas de assets resueltas acorde al tema.
 */
export default function useAppData() {
  const $ = _c(15);
  const {
    theme
  } = useTheme();
  const t0 = APP_DATA.branding.logo[theme];
  let t1;
  if ($[0] !== t0) {
    t1 = {
      logo: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = APP_DATA.footer.logos.nextGenEU[theme];
  const t3 = APP_DATA.footer.logos.minTdfp[theme];
  const t4 = APP_DATA.footer.logos.prtr[theme];
  const t5 = APP_DATA.footer.logos.incibe[theme];
  const t6 = APP_DATA.footer.logos.iso9001[theme];
  const t7 = APP_DATA.footer.logos.iso27001[theme];
  const t8 = APP_DATA.footer.logos.ens[theme];
  const t9 = APP_DATA.footer.logos.validacionDnsh[theme];
  const t10 = APP_DATA.footer.logos.uneEn301549[theme];
  let t11;
  if ($[2] !== t10 || $[3] !== t2 || $[4] !== t3 || $[5] !== t4 || $[6] !== t5 || $[7] !== t6 || $[8] !== t7 || $[9] !== t8 || $[10] !== t9) {
    t11 = {
      logos: {
        nextGenEU: t2,
        minTdfp: t3,
        prtr: t4,
        incibe: t5,
        iso9001: t6,
        iso27001: t7,
        ens: t8,
        validacionDnsh: t9,
        uneEn301549: t10
      }
    };
    $[2] = t10;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t1 || $[13] !== t11) {
    t12 = {
      ...APP_DATA,
      branding: t1,
      footer: t11
    };
    $[12] = t1;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const appData = t12;
  return appData;
}